import React from 'react'

export const TermsOfUseContent = () => {
  return (
    <React.Fragment>
      <h2>About</h2>
      <p><em>Last Revised: October 18, 2021</em></p>
      <p>
        This Northwestern Mutual  (“We”, “Us”, “Our”, or “Northwestern Mutual”) Website provides information about 
        financial planning for consumers and does not sell products or services. The following terms and conditions 
        of use (the “Terms of Use”) govern access to and use of the learnvest.com website (collectively, the “Website”), 
        including content and functionality offered on or through the Website, whether as a guest or a registered user 
        (each user, a “User”). These Terms of Use include by reference the Northwestern Mutual Privacy Statement. 
      </p>
      <p>
        By using the Website, or affirmatively consenting to these Terms of Use, a User consents to these Terms of Use.
        Continued use of the Website indicates acceptance of any modified terms.
      </p>
      <h2>Accessing the Website and Account Security</h2>
      <p>
        We reserve the right to withdraw or amend this Website in Our sole discretion without notice. We will not be
        liable if, for any reason, all or any part of the Website is unavailable at any time or for any period.
      </p>
      <p>
        From time to time, We may restrict access to some parts of the Website or the entire Website. The User is
        responsible for making all arrangements necessary for the User to access the Website and ensure that all persons
        who access the Website through the User’s Internet connection are aware of these Terms of Use and comply with
        them.
      </p>

      <h2>Content</h2>
      <p>
        The information presented on or through the Website is made available solely for general information purposes.
        We do not warrant the accuracy, completeness or usefulness of this information. Any reliance placed on such
        information is strictly at the User’s own risk. We disclaim all liability and responsibility arising from any
        reliance placed on such materials by the User or any other visitor to the Website, or by anyone who may be
        informed of any of its contents.
      </p>
      <p>
        We are not responsible for the content of third party websites. Inclusion of hyperlinks to third party websites
        does not in any manner imply any endorsement of the material on those websites or association with their owners
        or operators.
      </p>

      <h2>Restrictions on Use</h2>
      <p>
        This Website is offered and available to Users who are 13 years of age or older. If a person does not meet the
        requirement, that person must not access or use the Website.
      </p>
      <p>
        By using this Website, a User represents and warrants that the User is of legal age to form a binding contract
        with Us. If a User is under 18 years of age, the User hereby affirmatively represents that (a) the User is at
        least 13 years of age, (b) the User has the consent of the User’s parent or guardian to use the Website, (c) the
        User has read all the applicable rights and authority to grant Us the rights in these Terms of Use, and (d) the
        User has read, understood, and agrees to be bound by this Agreement. If a person is under 18 and does not have
        parental consent, the person must not access or use the Website.
      </p>

      <p>
        In any interaction with this Website, a User agrees to refrain from:
      </p>
      <ul>
        <li>Any practice that floods a person with unwanted communication;</li>
        <li>Language, comments, statements or terminology that can be construed as offensive, derogatory, judgmental,
          demeaning, humiliating or disparaging;
        </li>
        <li>Linking to offensive websites, including those that are pornographic, racist or which advocate violence or
          prejudice against any group or individuals;
        </li>
        <li>Disclosing private information about others; and</li>
        <li>Use of copyrighted material from this Website without permission.</li>
      </ul>

      <p>
        Any person deemed to have violated any of the above standards or any other individual instance considered
        related to any of the above standards may be blocked from this Website and/or the offending content may be
        removed. If any violation of the above standards represents, indicates or suggests an intent or threat to break
        the law, the violator’s information, including ISP and IP address, will be provided to the appropriate law
        enforcement agencies.
      </p>

      <h2>Copyright</h2>
      <p>
        The entire content included in this Website, including but not limited to text, graphics or code, is copyrighted 
        as a collective work under the United States and other copyright laws, and is the property of The Northwestern 
        Mutual Life Insurance Company (“Northwestern Mutual”) or its licensors. The collective work includes works that 
        are licensed to Us. The User may display and, subject to any expressly stated restrictions or limitations relating 
        to specific material, download or print portions of the material from the different areas of the Website solely 
        for the User’s own individual, non-commercial use. Further, the User’s device may temporarily store copies of such 
        materials in RAM incidental to the User’s accessing and viewing those materials and the User may store files that 
        are automatically cached by the web browser for display enhancement purposes. No right, title or interest in or 
        to the Website or any content on the Website is transferred to the User, and all rights not expressly granted 
        are reserved by Northwestern Mutual. 
      </p>
      <p>
        Any other use, including but not limited to the reproduction, distribution, display or transmission of the
        content of or downloads from this Website is strictly prohibited, unless authorized by Us in writing prior to
        such use. The User further agrees not to change or delete any proprietary notices from materials downloaded from
        the Website.
      </p>

      <h2>Trademarks</h2>
      <p>
        All LearnVest trademarks, service marks and trade names and all related names, logos, designs, and slogans 
        used in the Website are trademarks or registered trademarks of Northwestern Mutual. The User must not 
        use such marks without the prior written permission of Northwestern Mutual. 
      </p>
      <h2>Disclaimer of Warranty</h2>
      <p>
        THE USER EXPRESSLY AGREES THAT USE OF THE WEBSITE IS AT THE USER’S SOLE RISK. THE WEBSITE IS PROVIDED ON 
        AN “AS IS” AND “AS AVAILABLE” BASIS. NORTHWESTERN MUTUAL EXPRESSLY DISCLAIMS ALL WARRANTIES OF ANY 
        KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, ANY WARRANTIES REGARDING DATA PRIVACY 
        OR DATA SECURITY. 
      </p>
      <h2>Limitation of Liability</h2>
      <p>
        THE USER EXPRESSLY AGREES THAT NORTHWESTERN MUTUAL SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL 
        OR CONSEQUENTIAL DAMAGES. THE USER SPECIFICALLY AGREES THAT NORTHWESTERN MUTUAL IS NOT RESPONSIBLE OR 
        LIABLE TO THE USER OR ANYONE ELSE FOR ANY VIOLATION OF THE RIGHTS OF ANY PARTY, INCLUDING, BUT NOT LIMITED 
        TO, INTELLECTUAL PROPERTY RIGHTS, RIGHTS OF PUBLICITY, OR RIGHTS OF PRIVACY. IF NORTHWESTERN MUTUAL IS FOUND 
        TO HAVE VIOLATED ANY OF THE USER’S RIGHTS, THE USER ACKNOWLEDGES AND AGREES THAT ANY DAMAGES RECOVERABLE 
        AGAINST NORTHWESTERN MUTUAL ARE LIMITED TO THE LESSER OF THE ACTUAL, PROVEN DAMAGES OR $10. 
      </p>
      <h2>Indemnification</h2>
      <p>
        The User agrees to indemnify, defend, and hold harmless Northwestern Mutual, its officers, directors, employees, 
        agents, affiliates, licensors and suppliers from and against all claims, liabilities, judgments, awards, costs, 
        losses, expenses, damages and fees, including reasonable attorneys’ fees resulting from any violation of these 
        Terms of Use, or any activity related to the User’s account (including negligent or wrongful conduct) by the 
        User or any other person accessing the Website using the User’s Internet connection. 
      </p>
      <h2>Term; Termination</h2>
      <p>
        These Terms of Use are applicable to each User upon the User accessing the Website. We may terminate these terms
        and conditions, or any part of them, without notice at any time. The provisions relating to Copyrights,
        Trademarks, Disclaimer of Warranty, Limitation of Liability, Indemnification and Miscellaneous shall survive any
        termination.
      </p>
      <h2>Notice</h2>
      <p>
        We may deliver notice by means of e-mail, a general notice on the Website, or by other reliable method to the
        address a User provides.
      </p>
      <h2>Governing Law and Jurisdiction</h2>
      <p>
        All matters relating to the Website and these Terms of Use and any dispute or claim arising therefrom or related
        thereto (in each case, including non-contractual disputes or claims), shall be governed by and construed in
        accordance with the internal laws of the State of Wisconsin without giving effect to any choice or conflict of
        law provision or rule. Any legal suit, action or proceeding arising out of or related to these Terms of Use or
        the Website shall be instituted exclusively in the federal courts of the United States or the courts of the
        State of Wisconsin, in each case located in the City of Milwaukee and County of Milwaukee. The User waives any
        objection or defenses to this venue including forum non conveniens.
      </p>
      <h2>Miscellaneous</h2>
      <p>
        Any cause of action or claim the User may have with respect to the Website must be commenced within one (1) year
        after the claim or cause of action arises. Our failure to insist upon or enforce strict performance of any
        provision of these Terms of Use shall not be construed as a waiver of any provision or right. We may assign Our
        rights and duties under this Agreement to any party at any time without notice. We are entitled to recover all
        costs and expenses in enforcing this Agreement, including attorneys’ fees.
      </p>
      <h2>Changes and Revisions</h2>
      <p>
        We reserve the right to amend these Terms of Use from time to time. Any material change to Our online privacy
        practices will be reflected in these Terms of Use. We will indicate the date these Terms of Use were last
        updated.
      </p>
      <h2>For More Information</h2>
      {/* <p>
        LearnVest is wholly owned by NM Planning Services, LLC, a subsidiary of The Northwestern Mutual Life Insurance
        Company (“Northwestern Mutual”).
      </p> */}
      <p>
        This Statement does not apply to any other Northwestern Mutual website.
      </p>
      <p>
        The Website is maintained by The Northwestern Mutual Life Insurance Company, 720 E. Wisconsin Avenue, Milwaukee,
        WI, 53202.
      </p>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./client/data/pages/termsofuse.js